import { VueConstructor } from 'vue';
import { VideoOverlayPresentation } from './VideoOverlayPresentation';

export const extendCommonPresentationOverlay = (
  ctor: VueConstructor,
  presentation: VideoOverlayPresentation,
): VueConstructor => ctor.extend({
  i18n: presentation.message,
});
